"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.makeFramedScreen = exports.FramedScreen = void 0;
const FramedScreenContainer_1 = require("./FramedScreenContainer");
const MemoizedNumber_1 = require("./MemoizedNumber");
const ObservableEntity_1 = require("./ObservableEntity");
class FramedScreen extends ObservableEntity_1.ObservableEntity {
}
exports.FramedScreen = FramedScreen;
function makeFramedScreen() {
    return new FramedScreenImp();
}
exports.makeFramedScreen = makeFramedScreen;
class FramedScreenImp extends FramedScreen {
    constructor() {
        super(...arguments);
        this.memoizeWidth = new MemoizedNumber_1.MemoizedNumber(0, this.notify);
        this.memoizeHeight = new MemoizedNumber_1.MemoizedNumber(0, this.notify);
        this._containerLookup = new Map();
    }
    get screenWidth() {
        return this.memoizeWidth.val;
    }
    set screenWidth(val) {
        this.memoizeWidth.val = val;
    }
    get screenHeight() {
        return this.memoizeHeight.val;
    }
    set screenHeight(val) {
        this.memoizeHeight.val = val;
    }
    get containers() {
        return Array.from(this._containerLookup.values());
    }
    addContainer(container) {
        this._containerLookup.set(container.id, container);
        this.notify();
    }
    addContainerByID(id) {
        const newContainer = FramedScreenContainer_1.makeFramedScreenContainer(id);
        this.addContainer(newContainer);
        return newContainer;
    }
    removeContainer(id) {
        const container = this._containerLookup.get(id);
        if (container) {
            this._containerLookup.delete(id);
            this.notify();
        }
    }
    hasContainer(id) {
        return this._containerLookup.has(id);
    }
    getContainerByID(id) {
        return this._containerLookup.get(id);
    }
}
